module.exports = __webpack_public_path__ + "static/media/signup-bg.09997af9.png";